import React from "react";
import styled from "styled-components";

type SuccessPageProps = {
  totalRiskScore: number | null;
  show: boolean;
  onClose: () => void;
};

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(151, 146, 146, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: #000;
  color: white;
  padding: 30px 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 660px;
  text-align: center;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 10px;
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
`;

const RiskBox = styled.div<{ bgColor: string }>`
  background-color: ${(props) => props.bgColor};
  padding: 40px 20px;
  color: white;
  border-radius: 5px;
  margin-top: 20px;
`;

const SuccessPage: React.FC<SuccessPageProps> = ({ totalRiskScore, show, onClose }) => {
  if (!show || !totalRiskScore) return null;

  let riskLevel = "";
  let message = "";
  let color = "";

  if (totalRiskScore > 16) {
    riskLevel = "High Risk";
    color = "#FF372F";
    message =
      "Stop work and talk to your People or Team Leader! Discuss your level of fatigue and agree on actions that will control the immediate risks to ensure your safety at work (if safe to do so). Also discuss a safe means of returning home after work. Do not recommence work until fatigue has been reduced or mitigations are in place.";
  } else if (totalRiskScore >= 5) {
    riskLevel = "Medium Risk";
    color = "#856A00";
    message =
      "Consider additional fatigue controls while continuing to monitor changes in fatigue levels.";
  } else {
    riskLevel = "Low Risk";
    color = "green";
    message =
      "Continue works in accordance with project risk assessment while monitoring changes in fatigue levels.";
  }

  return (
    <Backdrop>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>×</CloseButton>
        <RiskBox bgColor={color}>
          <h1>Risk Score: {totalRiskScore}</h1>
          <h2>Risk Level: {riskLevel}</h2>
          <p>{message}</p>
        </RiskBox>
      </ModalContainer>
    </Backdrop>
  );
};

export default SuccessPage;
